export function courseDetailsSelector(state, id) {
  return state.entities.courses.full[id]
}

export function courseDetailsStateSelector(state, id) {
  return state.local.courses.byId[id]
}
